export function buildRsvpAttributionRedirect(args: {
  eventSlug: string;
  eventRedirectUrl: string | null | undefined;
  ref: string | null;
}): string {
  const postRsvpDestination =
    args.eventRedirectUrl && args.eventRedirectUrl.trim().length > 0
      ? args.eventRedirectUrl
      : `/events/${args.eventSlug}`;
  const postAuthRedirectParams = new URLSearchParams({
    redirectUrl: postRsvpDestination,
  });
  if (args.ref) {
    postAuthRedirectParams.set("ref", args.ref);
  }
  return `/events/${args.eventSlug}/rsvp?${postAuthRedirectParams.toString()}`;
}
